import React from "react";
import { Box, Grid, Button, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Header from "../header/header";
import Sidebar from "../merchant/sidebar";
import Image from "../../assets/man-with-arms-crossed.jpg";

const Profile = () => {
  return (
    <Box display="flex" alignItems="center" p={2}>
      <IconButton color="primary" aria-label="Edit Profile">
        <EditIcon />
      </IconButton>
      <h4>Profile</h4>
      {/* profile logic */}
      <img
        src={Image}
        alt="User Profile"
        style={{
          width: "48px",
          height: "48px",
          borderRadius: "50%",
          marginLeft: "1rem",
        }}
      />
    </Box>
  );
};

const Notifications = () => {
  return (
    <Box display="flex" alignItems="center" p={2}>
      <IconButton color="default" aria-label="View All Notifications">
        <NotificationsIcon />
      </IconButton>
      <h4>Notifications</h4>
      {/* notifications logic*/}
    </Box>
  );
};

const AdminDashboard = () => {
  return (
    <>
      <Box m="20px" display="flex">
        <Sidebar />

        <Box ml="3rem" marginTop={2}>
          <Box
            mb="4rem"
            display="flex"
            ml={{ xs: "1rem", md: "2rem" }}
            justifyContent={{ xs: "center" }}
            sx={{ marginRight: { xs: "4rem" } }}
          >
            <Notifications />

            <Profile />
          </Box>

          <Header title="Welcome to your Dashboard," subtitle="John!" />

          <Grid container spacing={2}>
            {/* First Row */}
            <Grid item xs={6}>
              <Box
                justifyContent="space-between"
                alignItems="center"
                sx={{ display: { xs: "column", md: "flex" } }}
                p={2}
              >
                <Box display="flex" flexDirection="column">
                  <h4>Available Balance</h4>
                  <Button variant="contained" color="primary">
                    ksh 4000
                  </Button>
                </Box>

                <Box display="flex" flexDirection="column">
                  <h4>Pending Payment</h4>
                  <Button variant="contained" color="primary">
                    ksh 2000
                  </Button>
                </Box>

                <Box display="flex" flexDirection="column">
                  <h4>Deposit Payment</h4>
                  <Button variant="contained" color="primary">
                    Deposit
                  </Button>
                </Box>
              </Box>
            </Grid>

            {/* Second Row */}
            <Grid item xs={8}>
              <Box
                justifyContent="space-between"
                alignItems="center"
                sx={{
                  display: { xs: "column", md: "flex" },
                }} /**responsiveness */
                p={2}
              >
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ marginTop: "1rem" }}
                >
                  New Transactions
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ marginTop: "1rem" }}
                >
                  View Transactions
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ marginTop: "1rem" }}
                >
                  View Settlements
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default AdminDashboard;
